export const MODAL_NAMES = {
  LEGACY_CART_INSURANCE_OFFER_CATCHUP: 'LEGACY_CART_INSURANCE_OFFER_CATCHUP',
  CART_INSURANCE_OFFER_EXPLANATIONS: 'CART_INSURANCE_OFFER_EXPLANATIONS',
  CART_COLLECTION_POINTS: 'CART_COLLECTION_POINTS',
  CART_WARRANTY: 'WARRANTY_CART',
  CATCH_UP_INSURANCE_OFFER: 'CATCH_UP_INSURANCE_OFFER',
  VISIBLE_BY_VERIZON_PROMO_CODE: 'VISIBLE_BY_VERIZON_PROMO_CODE',
  RAKUTEN_PROMO_CODE: 'RAKUTEN_PROMO_CODE',
  GOOGLE_FI_PROMO_CODE: 'GOOGLE_FI_PROMO_CODE',
  RECOMMENDATIONS: 'RECOMMENDATIONS',
}

export const TOAST = {
  CART_COLLECTION_POINTS_SUBMIT_ERROR: 'CART_COLLECTION_POINTS_SUBMIT_ERROR',
  TOAST_CHECKOUT_ADDRESS_SWAP: 'TOAST_CHECKOUT_ADDRESS_SWAP',
}

export const DEBOUNCE_DELAY = 250

export const CHECKOUT_LOG_TYPES = {
  ADDRESS_SUBMIT_SHIPPING: 'CHECKOUT_ADDRESS_SUBMIT_SHIPPING',
  ADDRESS_SUBMIT_BILLING: 'CHECKOUT_ADDRESS_SUBMIT_BILLING',
  ADDRESS_SUBMIT_CONFIRMATION: 'CHECKOUT_ADDRESS_SUBMIT_CONFIRMATION',
  ADDRESS_SUBMIT_COLLECTION_POINT: 'CHECKOUT_ADDRESS_SUBMIT_COLLECTION_POINT',
}

export const PRODUCT_CATEGORY = {
  SMARTPHONE: 2,
  IPAD: 5,
  APPLE_WATCH: 170,
  APPLE_EARPHONES: 217,
  MACBOOK: 110,
  MACBOOK_M1: 528,
  LAPTOPS: 9,
}
